import React from 'react'
import './Feature.css'
import feaimg from './feature-img/electric-car-power-charging.jpg'

const Feature = () => {
  return (
    <div className='feature-main'>
        <div className="feature-head">
          <p>Features</p>
          <div className="feature-line"></div>
        </div>
        <div className="feature-content-main">
            <div className="feature-content">
              <div className="feature-content1">
                <div className="feature-content-head" data-aos="fade-up">
                  <p>Elevate your eco - journey</p>
                </div>
                <div className="feature-content-note" data-aos="fade-up">
                  <p>Elevate your eco-journey with AIZO Plug– India's trusted EV charging solution provider,
                  pioneering sustainable energy since 2015</p>
                </div>
              </div>
            </div>
            <div className="feature-content2">
              <div className="feature-content-img" data-aos="fade-up">
                <img src={feaimg} alt="" />
              </div>
              <div className="feature-content-box">
                <div className="feature-box" data-aos="fade-up">
                  <div className="feature-box-tec">
                    <p>Technology</p>
                  </div>
                  <div className="feature-box-head">
                    <p>Smart Security</p>
                  </div>
                  <div className="feature-box-content">
                    <p> Revolutionizing EV charging with smart security and cutting-edge
 technology by AIZO Plug</p>
                  </div>
                </div>
                <div className="feature-box" data-aos="fade-up">
                  <div className="feature-box-tec">
                    <p>Absolute</p>
                  </div>
                  <div className="feature-box-head">
                    <p>Client Satisfaction</p>
                  </div>
                  <div className="feature-box-content">
                    <p>Unconditional persistent meaningful guidance coupled with consistent support and
                    assistance.</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  )
}

export default Feature